import styled from "styled-components";
import { ReactComponent as HolderSquare } from "./holder-square.svg";

const HolderSquareIcon = styled(HolderSquare)``;

export default HolderSquareIcon;
